import '../../monitoring/charts/chart_view.js.coffee';# Added by Script 
Namespace 'CustomerVisualMode.Charts'

class CustomerVisualMode.Charts.HeatmapGraphChartView extends Monitoring.Views.Charts.ChartView
  initialize: (formattedData) ->
    @formattedData = formattedData

  renderChart: ->
    @chart = new Highcharts.Chart(@_highchartsOptions())

  setChartWidth: (crossDimensionView) ->
    el = crossDimensionView.$el
    isMaximized = crossDimensionView.widget.get('is_maximized')
    el.find('.highcharts-container, .processing').css('height', if isMaximized then 450 else 250)

  _highchartsOptions: ->
    {
      chart: {
        type: 'heatmap',
        renderTo: @$el[0]
      },
      title: {
        text: null
      },
      xAxis: {
        categories: @formattedData.outerDimensionCategories,
        title: null
      },
      yAxis: {
        categories: @formattedData.innerDimensionCategories,
        title: null
      },
      colorAxis: {
        min: 0,
        minColor: '#FFFFFF',
        maxColor: '#FFA500'
      },
      legend: {
        align: 'right',
        layout: 'vertical',
        margin: 0,
        verticalAlign: 'top',
        y: 25,
        symbolHeight: 280
      },
      series: [{
        borderWidth: 1,
        dataLabels: {
          enabled: true,
          color: '#000000'
        },
        data: @formattedData.data
      }],
    }

  updateData: (formattedData) ->
    @formattedData = formattedData
